import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getHealthProvidersName} from '../../services/getProvidersName';
import {useBookingStore} from '../../store/useBookingStore';

import {UseGetHealthProvidersNameQueryProps} from './types';
import {useProviderNamesStore} from '../../store/useProviderNamesStore';

function useGetHealthProvidersNameQuery({enabled}: UseGetHealthProvidersNameQueryProps) {
	const setGetProviderNamesState = useProviderNamesStore(state => state.setProvidersName);
	const bookingData = useBookingStore(state => state.bookingData);
	const {specialtyCode, unitCode, subSpecialtyCode} = bookingData;

	return useQuery({
		queryKey: [QUERY_KEYS.HEALTH_PROVIDERS_NAME, specialtyCode, unitCode, subSpecialtyCode],
		queryFn: async ({signal}) => {
			const names = await getHealthProvidersName({
				signal,
				cdEspecialidade: Number(specialtyCode),
				cdPrestadorJuridico: Number(unitCode),
				cdSubespecialidade: Number(subSpecialtyCode),
				nmPrestadorFisico: null,
			});

			setGetProviderNamesState(names);
			return names;
		},
		enabled,
		staleTime: 0,
		gcTime: 0,
	});
}

export {useGetHealthProvidersNameQuery};
